import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
import BreathLight from "@/pages/BreathLight/index.vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        type: { default: "info" },
        text: { type: Boolean, default: false },
        icon: { default: "" },
        iconClass: { default: "" },
        showClose: { type: Boolean, default: false }
    },
    emits: ["close"],
    setup(__props, { emit }) {
        const props = __props;
        const getClass = computed(() => props.text ? "is-text" : `${props.type}-text ${props.type}-bg-light`);
        return (_ctx, _cache) => {
            const _component_svg_icon = _resolveComponent("svg-icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["tag bodyBase", _unref(getClass)])
            }, [
                _renderSlot(_ctx.$slots, "icon", {}, () => [
                    (__props.icon)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (__props.icon === 'breath')
                                ? (_openBlock(), _createBlock(BreathLight, { key: 0 }))
                                : (_openBlock(), _createBlock(_component_svg_icon, {
                                    key: 1,
                                    "icon-class": __props.icon,
                                    class: "f-s-16",
                                    "class-name": __props.iconClass
                                }, null, 8, ["icon-class", "class-name"]))
                        ], 64))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["point", [__props.type + '-bg']])
                        }, null, 2))
                ]),
                _renderSlot(_ctx.$slots, "default"),
                (__props.showClose)
                    ? (_openBlock(), _createBlock(_component_svg_icon, {
                        key: 0,
                        "icon-class": "close-tab",
                        class: "f-s-16",
                        "class-name": "close",
                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('close')))
                    }))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
